export default function CountryBadge({ country, size = "sm" }) {
  const sizeClasses = {
    xs: "px-1.5 py-0.5 text-xs",
    sm: "px-2 py-1 text-xs",
    md: "px-2.5 py-1.5 text-sm",
    lg: "px-3 py-2 text-sm",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full bg-blue-100 text-blue-800 border border-blue-200 font-medium ${sizeClasses[size]}`}
    >
      {country}
    </span>
  );
}
